import { Link } from 'react-router-dom';
import { MapPin, Phone, Printer, Mail, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';

const socialLinks = [
  { name: 'Facebook', href: '#', icon: Facebook },
  { name: 'Twitter', href: '#', icon: Twitter },
  { name: 'LinkedIn', href: '#', icon: Linkedin },
  { name: 'Instagram', href: '#', icon: Instagram },
];

export function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          {/* Contact Information */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <div className="space-y-3">
              <p className="flex items-center gap-x-2">
                <MapPin className="h-5 w-5 text-blue-400" />
                <span>1100 Northside Forsyth Dr., Suite 210, Cumming, GA 30041</span>
              </p>
              <p className="flex items-center gap-x-2">
                <Phone className="h-5 w-5 text-blue-400" />
                <a href="tel:+14702393602" className="hover:text-blue-400">(470) 239-3602</a>
              </p>
              <p className="flex items-center gap-x-2">
                <Printer className="h-5 w-5 text-blue-400" />
                <span>(404) 698-3463</span>
              </p>
              <p className="flex items-center gap-x-2">
                <Mail className="h-5 w-5 text-blue-400" />
                <a href="mailto:clinic@juncosneuroconsulting.com" className="hover:text-blue-400">
                  clinic@juncosneuroconsulting.com
                </a>
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="hover:text-blue-400">About Us</Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-blue-400">Our Services</Link>
              </li>
              <li>
                <Link to="/patient-info/new-patients" className="hover:text-blue-400">New Patients</Link>
              </li>
              <li>
                <Link to="/resources/research" className="hover:text-blue-400">Research</Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-blue-400">Contact</Link>
              </li>
              <li>
                <Link to="/legal/hipaa-privacy-notice" className="hover:text-blue-400">HIPAA Privacy Notice</Link>
              </li>
            </ul>
          </div>

          {/* Hours & Social */}
          <div>
            <div className="mb-6">
              <h3 className="text-lg font-semibold mb-4">Office Hours</h3>
              <p>Monday–Thursday: 9:00 AM – 5:00 PM</p>
              <p>Friday: 9:00 AM – 12:00 PM</p>
            </div>
            
            <div>
              <h3 className="text-lg font-semibold mb-4">Follow Us</h3>
              <div className="flex space-x-4">
                {socialLinks.map((item) => {
                  const Icon = item.icon;
                  return (
                    <a
                      key={item.name}
                      href={item.href}
                      className="text-gray-400 hover:text-blue-400"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className="sr-only">{item.name}</span>
                      <Icon className="h-6 w-6" />
                    </a>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 border-t border-gray-800 pt-8 text-center">
          <p className="text-sm text-gray-400">
            © {new Date().getFullYear()} Juncos Neuro Consulting. All rights reserved.
          </p>
          <div className="mt-2 flex justify-center space-x-4 text-sm text-gray-400">
            <Link to="/legal/hipaa-privacy-notice" className="hover:text-blue-400">
              HIPAA Privacy Notice
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}